import React from 'react'

const SvgStarBonus = props => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor" {...props}>
    <path d="M9.99,0 C4.47,0 0,4.48 0,10 C0,15.52 4.47,20 9.99,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 9.99,0 Z M14.23,16 L10,13.45 L5.77,16 L6.89,11.19 L3.16,7.96 L8.08,7.54 L10,3 L11.92,7.53 L16.84,7.95 L13.11,11.18 L14.23,16 Z" />
  </svg>
)

export default SvgStarBonus
